import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Accesso non riuscito',
  checkingSession: 'Controllo della sessione…',
  redirectingToSignIn: 'Reindirizzamento all’accesso…',
  signingIn: 'Accesso in corso…',
  backToDashboard: 'Torna alla dashboard',
};
